import addWhiteIcon from './add.svg';
import addYellowIcon from './addYellow.svg';
import close from './close.svg';
import emptyT from './empty-t.png';
import emptyX from './empty-x.svg';
import guideT from './guide-t.gif';
import guideX from './guide-x.gif';
import faceStyleYellowIcon from './image-face-yellow.svg';
import faceStyleWhiteIcon from './image-face.svg';
import imageStyleYellowIcon from './image-style-yellow.svg';
import imageStyleWhiteIcon from './image-style.svg';
import selectedWhiteIcon from './selected.svg';
import selectedYellowIcon from './selectedYellow.svg';
import { isTalkie } from '../../utils';

export { default as collectIcon } from './collect.svg';
export { default as collectedIcon } from './collected.svg';
export { default as loadingBaseIcon } from './loadingBase.svg';
export { default as useImageIcon } from './use-image.svg';
export { default as stepLoadingIcon } from './stepLoading.svg';

export const emptyPreviewIcon = isTalkie ? emptyT : emptyX;
export const selectedIcon = isTalkie ? selectedWhiteIcon : selectedYellowIcon;
export const addIcon = isTalkie ? addWhiteIcon : addYellowIcon;
export const imageStyleIcon = isTalkie ? imageStyleWhiteIcon : imageStyleYellowIcon;
export const faceStyleIcon = isTalkie ? faceStyleWhiteIcon : faceStyleYellowIcon;
export const closeIcon = close;

export const guideGif = isTalkie ? guideT : guideX;
